import * as React from 'react'
import PropTypes from 'prop-types'

import CTAButton from '../CTAButton/CTAButton'
import {
  BlockContainer,
  CTAWrapper,
  TextContainer,
  Heading,
  Description,
  CTAButtonWrapper,
  CTAButtonContainer,
} from './styles'

/**
 * CTABlock Component
 * A call-to-action section with a heading and one or two buttons
 */
export default function CTABlock({
  heading = 'Lorem Ipsum Dolor',
  description = '',
  cta1Text = 'Buy Now',
  cta1Link,
  cta1Variant = false,
  cta1Analytics = 'Clicked_Builder CTA',
  hasDualCta = false,
  cta2Text = 'Buy Now',
  cta2Link,
  cta2Variant = false,
  cta2Analytics = 'Clicked_Builder CTA',
}) {
  return (
    <BlockContainer>
      <CTAWrapper>
        <TextContainer>
          <Heading>{heading}</Heading>
          {description && <Description>{description}</Description>}
        </TextContainer>
        <CTAButtonWrapper>
          <CTAButtonContainer>
            <CTAButton ctaLink={cta1Link} ctaVariant={cta1Variant} ctaAnalytics={cta1Analytics}>
              {cta1Text}
            </CTAButton>
          </CTAButtonContainer>
          {hasDualCta && (
            <CTAButtonContainer>
              <CTAButton ctaLink={cta2Link} ctaVariant={cta2Variant} ctaAnalytics={cta2Analytics}>
                {cta2Text}
              </CTAButton>
            </CTAButtonContainer>
          )}
        </CTAButtonWrapper>
      </CTAWrapper>
    </BlockContainer>
  )
}

CTABlock.propTypes = {
  heading: PropTypes.string,
  description: PropTypes.string,
  cta1Text: PropTypes.string,
  cta1Link: PropTypes.string,
  cta1Variant: PropTypes.bool,
  cta1Analytics: PropTypes.string,
  hasDualCta: PropTypes.bool,
  cta2Text: PropTypes.string,
  cta2Link: PropTypes.string,
  cta2Variant: PropTypes.bool,
  cta2Analytics: PropTypes.string,
}
